<template>
  <b-columns is-multiline>
    <b-column
      class="is-full-mobile is-half-desktop"
      v-for="(samplingType, idx) in agentSamplingTypes"
      :key="idx"
    >
      <collapsible-card :heading="samplingType.samplingType.name">
        <sampling-type :data="samplingType.samplingType" />
        <analysis-methods :analysis-methods="samplingType.analysis_methods" />
      </collapsible-card>
    </b-column>
  </b-columns>
</template>

<script>
import { mapGetters } from 'vuex'
import CollapsibleCard from '@/components/structures/CollapsibleCard'
import SamplingType from '@/components/material/SamplingType'
import AnalysisMethods from './AnalysisMethods'

export default {
  components: {
    CollapsibleCard,
    SamplingType,
    AnalysisMethods
  },
  computed: {
    ...mapGetters(['agentSamplingTypes'])
  }
}
</script>

<style>
</style>
